import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';

import {
  FormValidationModule,
  TimepickerModule,
} from '@tablesready/common-ui';
import { SchedulesComponent } from './schedules.component';
import { AddEditScheduleComponent } from './modals/add-edit-schedule/add-edit-schedule.component';
import { CloseDayScheduleComponent } from './modals/close-day-schedule/close-day-schedule.component';
import { SchedulesRoutingComponent } from './schedules.routing.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { IonicModule } from '@ionic/angular';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    SchedulesComponent,
    AddEditScheduleComponent,
    CloseDayScheduleComponent
  ],
  imports: [
    FrontendIconsModule,
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    TimepickerModule,
    Angulartics2Module,
    SchedulesRoutingComponent,
    IonicModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
  ],
})
export class SchedulesModule {}
